import request from '../request';
// export const AccountUsersMobileAccountIndex = (axios, params) => {
//   return request({
//     url: '/v1/account/users/index',
//     method: 'get',
//     params
//   })
// }
// 升级会员生成订单
export const orderCreateByMembership = (params) => {
  return request({
    url: '/v1/improved_orders/order_create_by_membership',
    method: 'post',
    data: params
  })
}

// navbar
// export const personMenu = (params) => {
//   return request({
//     url: '/v1/person_menu',
//     method: 'get',
//     params
//   })
// }


// import api from '../api-methods'

// const me = {
//   AccountUsersMobileAccountIndex: params => {
//     return api.get('/v1/account/users/index', params)
//   },
//   // 超级会员展示页
//   MobileAccountUsersBuyMember: params => {
//     return api.get('/v1/account/users/buy_member', params)
//   },
//   feedback: params => {
//     return api.get('/v1/feedbacks/new', params)
//   },
//   feedbackSubmit: params => {
//     return api.post('/v1/feedbacks/create', params)
//   },

//   // 获取accout/users/current 页面数据
//   getAccountUsersCurrent: params => {
//     return api.get('/v1/account/users/current', params)
//   },
//   // 获取accout/users 页面数据
//   getAccountUsersInfo: params => {
//     return api.get('/v1/account/users/info', params)
//   },
//   // 获取accout/orders 页面订单数据
//   getAccountOrders: params => {
//     return api.get('/v1/account/orders/index', params)
//   },
//   // 提交兑换码
//   postExchangeCode: params => {
//     return api.post('/v1/improved_orders/invitation_partner', params)
//   },

//   // 登录获取Udesk在线客服跳转链接
//   getUdeskOnlineUrl: params => {
//     return api.get('/v1/account/users/udesk_online_url', params)
//   },
//   getCurrentUser: params => {
//     return api.get(process.env.HOST_ROOT + '/get_current_user', params)
//   },
//   // 超级会员续费
//   createImprovedOrder: params => {
//     return api.post(process.env.HOST_ROOT + '/orders', params)
//   },
//   // 获取微信js config
//   getWechatJsConfig: params => {
//     return api.get('/v1/get_wechat_config', params)
//   },
//   // 获取用户基本信息
//   getUserBasicInfo: params => {
//     return api.get('/v1/account/users/basic_info', params)
//   },
//   submitBasicInfo: params => {
//     return api.post('/v1/account/users/update_basic_info', params)
//   },
//   // 修改devise 登录后跳转路径session_key, 自动跳回页面
//   storeLocation: params => {
//     return api.get(process.env.HOST_ROOT + '/interface/apis/store_location', params)
//   },
//   // 获取用户手机或邮箱验证码
//   getValidateCode: params => {
//     return api.post('/v1/get_validate_code', params)
//   },
//   forgetPassword: params => {
//     return api.get('/v1/forget_password', params)
//   },
//   updateInfo: params => {
//     return api.post('/v1/account/users/update_info', params)
//   },
//   cancelOrder: params => {
//     return api.post('/v1/account/orders/cancel', params)
//   },
//   queryOrder: params => {
//     return api.post('/v1/account/orders/query', params)
//   }
// }

// export default me


// v3
export const getUserInfo = (cv_account_token, params) => {
  return request({
    url: `/v3/cv_accounts/${cv_account_token}`,
    method: 'get',
    params
  })
}
export const updateUserInfo = (cv_account_token, params) => {
  return request({
    url: `/v3/cv_accounts/${cv_account_token}`,
    method: 'put',
    data: params
  })
}
 // 更改用户职业方向
 export const updateUserIntention = (cv_account_token, params) => {
  return request({
    url: `/v3/cv_accounts/${cv_account_token}/job_status`,
    method: 'put',
    data: params
  })
}
 // 获取用户积分
  export const getUserScore = token => {
    return request({
      url: `/v3/cv_accounts/${token}/tracks?category=points`, // 只返回积分数是否签到
      method: 'get'
    })
  }
  